import type { IconData } from '@stacksjs/iconify-core'

export const clipboard: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M5 2v2h4V2zm6 0h1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2m0 2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2H2v14h10V4zM4 8h6a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2m0 5h6a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default clipboard
